import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

export class IconRegistry {
  static registerIcon(
    iconRegistry: MatIconRegistry,
    sanitizer: DomSanitizer
  ): void {
    iconRegistry.addSvgIcon(
      'ic-help',
      sanitizer.bypassSecurityTrustResourceUrl('/assets/icons/ic-help.svg')
    );
    iconRegistry.addSvgIcon(
      'eye-show',
      sanitizer.bypassSecurityTrustResourceUrl('/assets/icons/eye-show.svg')
    );
    iconRegistry.addSvgIcon(
      'eye-hide',
      sanitizer.bypassSecurityTrustResourceUrl('/assets/icons/eye-hide.svg')
    );
    iconRegistry.addSvgIcon(
      'info-circle',
      sanitizer.bypassSecurityTrustResourceUrl('/assets/icons/info-circle.svg')
    );
    iconRegistry.addSvgIcon(
      'info-circle-filled',
      sanitizer.bypassSecurityTrustResourceUrl(
        '/assets/icons/info-circle-filled.svg'
      )
    );
    iconRegistry.addSvgIcon(
      'arrow-up',
      sanitizer.bypassSecurityTrustResourceUrl('/assets/icons/arrow-up.svg')
    );
    iconRegistry.addSvgIcon(
      'arrow-down',
      sanitizer.bypassSecurityTrustResourceUrl('/assets/icons/arrow-down.svg')
    );
    iconRegistry.addSvgIcon(
      'search',
      sanitizer.bypassSecurityTrustResourceUrl('/assets/icons/search.svg')
    );
    iconRegistry.addSvgIcon(
      'home-charging',
      sanitizer.bypassSecurityTrustResourceUrl(
        '/assets/icons/home-charging.svg'
      )
    );
    iconRegistry.addSvgIcon(
      'copy',
      sanitizer.bypassSecurityTrustResourceUrl('/assets/icons/copy.svg')
    );
    iconRegistry.addSvgIcon(
      'document-download',
      sanitizer.bypassSecurityTrustResourceUrl(
        '/assets/icons/document-download.svg'
      )
    );
    iconRegistry.addSvgIcon(
      'gps',
      sanitizer.bypassSecurityTrustResourceUrl('/assets/icons/gps.svg')
    );
  }
}
